var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { DateTime } from "luxon";
import React, { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTime } from "../hooks/customHooks";
import { ProgrammingExercise } from "./ProgrammingExercise";
import { getSubmissionResults, postExerciseFeedback, postExerciseSubmission } from "../services/programming_exercise";
import Notification from "./Notification";
import useExercise from "../hooks/useExercise";
var ProgrammingExerciseLoader = function (_a) {
  var _b, _c, _d, _e, _f;
  var onExerciseDetailsChange = _a.onExerciseDetailsChange,
    organization = _a.organization,
    course = _a.course,
    exercise = _a.exercise,
    token = _a.token,
    userId = _a.userId,
    height = _a.height,
    outputHeight = _a.outputHeight,
    debug = _a.debug,
    _g = _a.language,
    language = _g === void 0 ? "en" : _g;
  var time = useTime(10000);
  var _h = useTranslation(),
    t = _h[0],
    i18n = _h[1];
  var exerciseObject = useExercise(organization, course, exercise, userId, token);
  var apiConfig = {
    t: t,
    token: token
  };
  var signedIn = userId && token;
  var exerciseDefined = organization && course && exercise;
  var cacheKey = signedIn && exerciseDefined ? userId + ":" + organization + "-" + course + "-" + exercise : undefined;
  var submitAndWaitResult = useCallback(function (files) {
    return __awaiter(void 0, void 0, void 0, function () {
      var wrapError, postResult, submissionResult, e_1, e_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            wrapError = function (message) {
              return {
                points: [],
                testCases: [{
                  id: "0",
                  testName: "Exercise submission",
                  passed: false,
                  feedback: "Error " + message
                }]
              };
            };
            if (!exerciseObject.details) {
              return [2, wrapError("418: Exercise details missing")];
            }
            _a.label = 1;
          case 1:
            _a.trys.push([1, 7,, 8]);
            return [4, postExerciseSubmission(exerciseObject.details.id, files, apiConfig)];
          case 2:
            postResult = _a.sent();
            _a.label = 3;
          case 3:
            _a.trys.push([3, 5,, 6]);
            return [4, getSubmissionResults(postResult, apiConfig)];
          case 4:
            submissionResult = _a.sent();
            exerciseObject.updateDetails();
            return [2, submissionResult];
          case 5:
            e_1 = _a.sent();
            return [2, wrapError(e_1.message)];
          case 6:
            return [3, 8];
          case 7:
            e_2 = _a.sent();
            return [2, wrapError(e_2.message)];
          case 8:
            return [2];
        }
      });
    });
  }, [exerciseObject.details]);
  var submitToPaste = function (files) {
    return __awaiter(void 0, void 0, void 0, function () {
      var submitResult, e_3;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!exerciseObject.details) {
              return [2, ""];
            }
            _b.label = 1;
          case 1:
            _b.trys.push([1, 3,, 4]);
            return [4, postExerciseSubmission(exerciseObject.details.id, files, apiConfig, {
              paste: true
            })];
          case 2:
            submitResult = _b.sent();
            return [2, (_a = submitResult.pasteUrl) !== null && _a !== void 0 ? _a : ""];
          case 3:
            e_3 = _b.sent();
            return [2, Promise.reject(e_3.message)];
          case 4:
            return [2];
        }
      });
    });
  };
  useEffect(function () {
    var exerciseDetails = exerciseObject.details;
    if (exerciseDetails && exerciseDetails.deadline && !exerciseDetails.expired && time >= DateTime.fromISO(exerciseDetails.deadline)) {
      exerciseObject.updateDetails();
    }
  }, [exerciseObject, time]);
  useEffect(function () {
    onExerciseDetailsChange === null || onExerciseDetailsChange === void 0 ? void 0 : onExerciseDetailsChange(exerciseObject.details);
  }, [exerciseObject.details, onExerciseDetailsChange]);
  useEffect(function () {
    i18n.changeLanguage(language);
  }, [language]);
  var submitDisabled = ((_b = exerciseObject.details) === null || _b === void 0 ? void 0 : _b.expired) || !((_c = exerciseObject.details) === null || _c === void 0 ? void 0 : _c.downloadable) || !signedIn;
  return React.createElement("div", null, !signedIn && React.createElement(Notification, {
    style: "warning"
  }, t("signInToSubmitExercise")), ((_d = exerciseObject.details) === null || _d === void 0 ? void 0 : _d.expired) && React.createElement(Notification, {
    style: "warning"
  }, t("deadlineExpired")), React.createElement(ProgrammingExercise, {
    cacheKey: cacheKey,
    debug: debug,
    exercise: exerciseObject,
    submitFeedback: function (testResults, feedback) {
      if (testResults.feedbackAnswerUrl && feedback.length > 0) {
        postExerciseFeedback(testResults, feedback, apiConfig);
      }
    },
    submitProgrammingExercise: submitAndWaitResult,
    submitToPaste: submitToPaste,
    submitDisabled: submitDisabled,
    editorHeight: height,
    outputHeight: outputHeight,
    solutionUrl: ((_e = exerciseObject.details) === null || _e === void 0 ? void 0 : _e.completed) || ((_f = exerciseObject.details) === null || _f === void 0 ? void 0 : _f.expired) ? "https://tmc.mooc.fi/exercises/" + exerciseObject.details.id + "/solution" : undefined
  }));
};
export { ProgrammingExerciseLoader };